"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorAnalyticsService = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var saWrapper_1 = __importDefault(require("../saWrapper"));
var constants_1 = require("../constants");
var fieldWhitelist_1 = require("../constants/fieldWhitelist");
var types_1 = require("../types");
var SensorAnalyticsService = /** @class */ (function () {
    function SensorAnalyticsService() {
    }
    SensorAnalyticsService.prototype.addActionTime = function (data) {
        data.action_time = Date.now();
        return data;
    };
    SensorAnalyticsService.prototype.generateDataWithPrefix = function (data, event) {
        var result = {};
        var whitelist = fieldWhitelist_1.noPrefixFields.common;
        if (event && fieldWhitelist_1.noPrefixFields[event]) {
            whitelist = whitelist.concat(fieldWhitelist_1.noPrefixFields[event]);
        }
        for (var i in data) {
            if (whitelist.indexOf(i) > -1) {
                result[i] = data[i];
            }
            else {
                result["".concat(this.sdkConfigService.get().prefix, "_").concat(i)] = data[i];
            }
        }
        return result;
    };
    SensorAnalyticsService.prototype.autoTrack = function () {
        if (this.sdkConfigService.get().autoTrack) {
            saWrapper_1.default.quick("autoTrack");
        }
    };
    SensorAnalyticsService.prototype.isSDKConfigValid = function () {
        var checkKeys = ["appName", "countryId", "countryCode", "userId"];
        var config = this.sdkConfigService.get();
        var keys = Object.keys(config);
        var valid = true;
        for (var i = 0; i++; i < keys.length) {
            if (checkKeys.indexOf(keys[i]) > -1 && !config[keys[i]]) {
                valid = false;
                break;
            }
        }
        return valid;
    };
    SensorAnalyticsService.prototype.registerPage = function (userId) {
        var _a = this.sdkConfigService.get(), appName = _a.appName, rest = __rest(_a, ["appName"]);
        saWrapper_1.default.registerPage(__assign({ app_name: appName }, this.generateDataWithPrefix({
            self_uid: (userId === null || userId === void 0 ? void 0 : userId.toString()) || "",
            country_id: rest.countryId.toString(),
            country_name: rest.countryCode.toString(),
        })));
    };
    SensorAnalyticsService.prototype.init = function (config) {
        saWrapper_1.default.init({
            server_url: config.serverUrl ||
                (config.env === "prod"
                    ? "https://sc.akulaku.com/sa?project=production"
                    : "https://sc.akulaku.com/sa"),
            heatmap_url: config.heatmapUrl || constants_1.HEATMAP_URL,
            heatmap: __assign({ 
                // 关闭自动上报click事件
                clickmap: "not_collect", 
                // 关闭自动上报WebStay事件
                scroll_notice_map: "not_collect" }, config.heatmapOptions),
            // 开启spa模式，自动上报pageview事件
            // is_track_single_page: true,
            // 开启console调试
            show_log: typeof config.showLog === "undefined" ? true : config.showLog,
            // debug模式
            debug_mode: !!config.isDebug,
            send_type: "beacon",
            use_app_track: false,
            batch_send: {
                datasend_timeout: 6000,
                send_interval: 5000,
            },
        });
        this.login(config.userId);
    };
    SensorAnalyticsService.prototype.track = function (event, data) {
        if (!this.sdkConfigService.get().enabled) {
            // console.warn("非 sa 上报环境，暂停上报");
            return;
        }
        if (this.sdkConfigService.get().filterEventObj.enabled &&
            !this.sdkConfigService.get().filterEventObj.eventArr.includes(event)) {
            // 工程开启了过滤事件，并且上报的的事件名不符合规范就暂停上报
            return;
        }
        saWrapper_1.default.track(event, data);
    };
    SensorAnalyticsService.prototype.trackWithPrefix = function (event, data) {
        var eventName = "".concat(this.sdkConfigService.get().prefix, "_").concat(event);
        var _a = data || {}, noPrefixData = _a.noPrefixData, rest = __rest(_a, ["noPrefixData"]);
        var _b = this.pageConfigService.get() || {}, disableVisibilityHandler = _b.disableVisibilityHandler, restPageConfig = __rest(_b, ["disableVisibilityHandler"]);
        this.track(eventName, __assign(__assign({}, noPrefixData), this.generateDataWithPrefix(__assign(__assign(__assign({}, restPageConfig), this.addActionTime(rest)), { page_id: "".concat(restPageConfig.page_id || "") }))));
    };
    SensorAnalyticsService.prototype.tracking = function (event, data) {
        var eventName = "".concat(this.sdkConfigService.get().prefix, "_").concat(event);
        var _a = data || {}, noPrefixData = _a.noPrefixData, rest = __rest(_a, ["noPrefixData"]);
        this.track(eventName, __assign(__assign({}, noPrefixData), this.generateDataWithPrefix(__assign({}, rest), event)));
    };
    SensorAnalyticsService.prototype.login = function (userId) {
        if (userId) {
            saWrapper_1.default.login(userId);
            this.sdkConfigService.update({
                userId: userId,
            });
        }
        if (this.isSDKConfigValid()) {
            this.registerPage(userId);
            this.autoTrack();
        }
    };
    SensorAnalyticsService.prototype.logout = function (isChangeId) {
        saWrapper_1.default.logout(isChangeId);
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.SDKConfigService),
        __metadata("design:type", Object)
    ], SensorAnalyticsService.prototype, "sdkConfigService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.PageConfigService),
        __metadata("design:type", Object)
    ], SensorAnalyticsService.prototype, "pageConfigService", void 0);
    SensorAnalyticsService = __decorate([
        (0, inversify_1.injectable)()
    ], SensorAnalyticsService);
    return SensorAnalyticsService;
}());
exports.SensorAnalyticsService = SensorAnalyticsService;
